import FrontPage from './Part1';

export default FrontPage;
